import { withStyles } from '@material-ui/core';
import { StyleRules } from '@material-ui/core/styles';

export function WithStyles(styles: StyleRules<any> | any, options?: any) {
  return function<T>(target: T): T {
    return withStyles(styles, options)(target as any) as any;
  };
}

export type AppStyle<Classkeys extends string = string> = StyleRules<Classkeys> | any;

export type ClassesFrom<AppStyle> = {
  [key in AppStyle extends any ? keyof ReturnType<any> : keyof AppStyle]: string;
};

export interface IStyledProps<T = any> {
  classes?: ClassesFrom<T>;
}
